import { defineComponent as _defineComponent } from 'vue'
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import { RegistrationItem, useRegistrationSingle } from "@/services/TablePage/registrations";
import { computed, onBeforeMount, ref, onMounted } from "vue";
import { useRoute } from "vue-router/composables";
import { getRegistrationSingle } from "@/api/registrations";
import { showServerError } from "@/utils";
import { IRegistration } from "@/api/types/registrations";
import SvgCheck from "@/assets/icons/check.svg";
import SvgExclamation from "@/assets/icons/exclamation.svg";
import BaseListV2 from "@/components-UI/list/BaseListV2.vue";
import ViewDateTime from "@/components/base/ViewDateTime.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import { useCopyText } from "@/utils/copyText";
import BaseChip from "@/components-UI/BaseChip.vue";
import { useCalculateTextWidth } from "@/utils/calculateTextWidth";
import { setWindowTitle } from "@/services/TablePage/reportPreset";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationSingle',
  setup(__props) {

const route = useRoute();
const isLoading = ref(true);
const isRegistrationCompleted = ref(true);
const registration = ref<IRegistration>({});

const { getCards } = useRegistrationSingle();
const cards = ref({});

const getTitle = computed(() => {
    const { id, first_name, last_name } = registration.value;
    return `${id || ''} ${first_name || ''} ${last_name || ''}`;
});

onBeforeMount(() => {
    getRegistration();
});

const getRegistration = async () => {
    try {
        const id = route.params.id!;
        const { data } = await getRegistrationSingle(id);
        registration.value = data;
        isRegistrationCompleted.value = !!data.completed;
        cards.value = getCards(data);
    } catch (err) {
        showServerError(err, 'Ошибка загрузки регистрации');
    } finally {
        isLoading.value = false;
    }
};

const isDisabledTooltip = (item: RegistrationItem) => {
    return (item.isClamp && !isClamped(item.value)) || !item.tooltip;
};

const isClamped = (text) => {
    const valueWidth = getValueWidth.value;
    const textWidth = useCalculateTextWidth(text, { font: 'Inter, sans-serif', fontSize: 14, letterSpacing: 0.28 });
    return textWidth > valueWidth;
};

const listEls = ref(null);
const getValueWidth = computed(() => {
    const lists = listEls.value as HTMLElement;
    if (!lists) return 0;
    const list = lists[0].$el;
    const item = list.querySelector('.base__list-item');
    const label = item.querySelector('.base__list-label');
    return item.clientWidth - label.clientWidth;
});

const copy = (item: RegistrationItem) => {
    if (isEnabledCopy(item)) {
        useCopyText(item.value, 'Скопировано');
    }
};

const isEnabledCopy = (item: RegistrationItem) => {
    return item.isLink || (item.isCopyOnClick && !isDisabledTooltip(item));
};

onMounted((): void => {
    setWindowTitle(`Регистрация ${route.params.id}`);
});

return { __sfc: true,route, isLoading, isRegistrationCompleted, registration, getCards, cards, getTitle, getRegistration, isDisabledTooltip, isClamped, listEls, getValueWidth, copy, isEnabledCopy, PageLayout, BaseEditableCard, SvgCheck, SvgExclamation, BaseListV2, ViewDateTime, BaseTooltip, BaseChip }
}

})